<template>
  <!--    图片添加修改-->
  <div class="imageBox" v-loading="showLoading">
    <el-form ref="form" :model="audioPack" label-width="120px">
      <el-form-item label="上传语音文件" class="upload-item">
        <el-upload
            drag
            class="upload-demo upload-large"
            action="none"
            :file-list="audioPack.fileList"
            :on-exceed="imageCountOut"
            :on-remove="handleRemove"
            :on-change="fileChange"
            :before-upload="beforeUpload"
            :auto-upload="false"
            :limit="1"
            accept="audio/*">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将语音文件拖拽到此处，或<em>点击上传</em></div>
          <div slot="tip" class="el-upload__tip">只能上传一个文件，且不超过20MB</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="语音:" v-show="isShowFontPreview">
        <div class="font_preview">
          <audio ref="audio" controls="" :src="audioPack.url"/>
        </div>
      </el-form-item>
      <el-form-item label="语音包名">
        <el-input v-model="audioPack.name" class="input"></el-input>
      </el-form-item>
      <el-form-item label="分组标签">
        <el-input v-model="audioPack.tag" class="input" placeholder="支持xx-xxx"></el-input>
      </el-form-item>
      <el-form-item label="更多标签">
        <el-input v-model="audioPack.moreTag" class="input" placeholder="用于搜索的扩展标签"></el-input>
      </el-form-item>
      <el-form-item label="总热度">
        <el-input v-model="audioPack.heat" class="input" type="number"></el-input>
      </el-form-item>
      <el-form-item label="支持克隆">
        <el-select v-model="audioPack.supportClone" class="input">
          <el-option label="支持" :value="1"></el-option>
          <el-option label="不支持" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否加锁">
        <el-select v-model="audioPack.isLock" class="input">
          <el-option label="无锁" :value="0"></el-option>
          <el-option label="加锁" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="btn">
        <el-button type="primary" size="large" @click="save">保存</el-button>
        <el-button size="large" @click="cancel">取消</el-button>
      </el-form-item>
      <el-form-item label="批量分组标签">
        <el-input v-model="batchUploadTag" class="input" placeholder="统一应用到所有语音包"></el-input>
      </el-form-item>
      <el-form-item label="批量上传">
        <el-upload
            class="upload-demo"
            action="none"
            multiple
            :file-list="batchFileList"
            :on-change="onBatchFileChange"
            :on-remove="onBatchFileRemove"
            :before-upload="beforeBatchUpload"
            :auto-upload="false"
            :limit="50"
            accept="audio/*">
          <el-button size="small" type="primary">选择语音文件(≤50)</el-button>
          <div slot="tip" class="el-upload__tip">并发不超过5，支持断点续传</div>
        </el-upload>
        <div class="btn">
          <el-button type="success" :disabled="!canStartBatch" @click="startBatchUpload">批量上传</el-button>
        </div>
      </el-form-item>
      <el-form-item label="上传进度" v-if="batchTasks.length">
        <el-table
            class="table"
            border
            :data="batchTasks"
            style="width: 100%">
          <el-table-column align="center" prop="name" label="文件名" width="320"></el-table-column>
          <el-table-column align="center" label="大小(kb)" width="120">
            <template slot-scope="scope">
              <span>{{ (scope.row.size / 1024).toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="进度">
            <template slot-scope="scope">
              <el-progress :percentage="scope.row.progress" :status="scope.row.progressStatus"></el-progress>
            </template>
          </el-table-column>
          <el-table-column align="center" label="状态" width="120">
            <template slot-scope="scope">
              <el-tag :type="statusTagType(scope.row.status)">{{ statusText(scope.row.status) }}</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "AudioPackEdit",
  props: ['audioPack', "isUpdate", "isTemplateInto"],
  data: function () {
    return {
      music_path: "",
      showLoading: false,
      fontName: "",
      name: "",
      isShowFontPreview: false,
      fontImagePreview: null,//字体预览文件
      batchUploadTag: "",
      batchFileList: [],
      batchTasks: [],
      uploadingBatch: false,
      concurrency: 5,
      chunkSize: 4 * 1024 * 1024,
      retryLimit: 3
    }
  },
  computed: {
    canStartBatch: function () {
      return this.batchUploadTag && this.batchTasks.length > 0 && !this.uploadingBatch;
    }
  },
  methods: {
    // 文件上传前回调   createObjectURL 会创建一个 url 地址
    beforeUpload(file) {
      this.fileList.push({
        src: URL.createObjectURL(file),
        name: file.name,
        id: new Date().getTime()
      })
    },
    imageCountOut: function () {
      this.showErrorMessage("只能选择一个文件")
    },
    /**
     * 图片移除回调
     * @param file
     * @param fileList
     */
    handleRemove: function (file, fileList) {
      this.audioPack.file = null
      this.isShowFontPreview = false
    },
    /**
     * 图片选择回调
     * @param file
     */
    fileChange: function (file) {
      this.isShowFontPreview = true
      this.audioPack.file = file.raw
      this.audioPack.url = URL.createObjectURL(file.raw)
      console.log(" file " + this.audioPack.url)

      //设置名字、热度
      this.$set(this.audioPack, "name", file.raw.name.substring(0, file.raw.name.indexOf('.')))
      this.$set(this.audioPack, "heat", 4000)
    },
    /**
     * 显示错误信息弹框
     * @param msg 错误信息弹框
     */
    showErrorMessage: function (msg) {
      this.$confirm(msg, "提示", {
        confirmButtonText: '确定',
        showClose: false,
        showCancelButton: false,
        center: true,
        type: 'error'
      })
    },
    cancel: function () {
      this.$emit('saveStatus', false)
    },
    /**
     * 保存上传
     * */
    save() {
      if (!this.isUpdate) {
        this.addAudioPack()
      } else {
        this.updateAudioPack()
      }
    },
    beforeBatchUpload(file) {
      const isAudio = file.type && file.type.startsWith('audio/');
      const isLt20M = file.size / 1024 / 1024 <= 20;
      return isAudio && isLt20M;
    },
    onBatchFileChange(file, fileList) {
      this.batchFileList = fileList.slice(0, 50);
      this.batchTasks = this.batchFileList.map((f, idx) => ({
        id: Date.now() + '_' + idx,
        file: f.raw || f,
        name: (f.name || (f.raw && f.raw.name)) || '',
        size: (f.size || (f.raw && f.raw.size)) || 0,
        progress: 0,
        progressStatus: 'normal',
        status: 'queued',
        uploadedChunks: 0,
        totalChunks: 0,
        hash: '',
        retries: 0
      }));
    },
    onBatchFileRemove(file, fileList) {
      this.batchFileList = fileList;
      const name = file.name;
      this.batchTasks = this.batchTasks.filter(t => t.name !== name);
    },
    statusTagType(status) {
      if (status === 'completed') return 'success';
      if (status === 'failed') return 'danger';
      if (status === 'uploading') return 'warning';
      return 'info';
    },
    statusText(status) {
      if (status === 'completed') return '完成';
      if (status === 'failed') return '失败';
      if (status === 'uploading') return '上传中';
      return '等待';
    },
    startBatchUpload: async function () {
      if (!this.batchTasks.length || !this.batchUploadTag) return;
      this.uploadingBatch = true;
      let active = 0;
      let cursor = 0;
      const next = () => {
        while (active < this.concurrency && cursor < this.batchTasks.length) {
          const task = this.batchTasks[cursor++];
          active++;
          this.uploadSingleTask(task).then(() => {
            active--;
            next();
          }).catch(() => {
            active--;
            next();
          });
        }
        if (active === 0 && cursor >= this.batchTasks.length) {
          this.uploadingBatch = false;
          this.$emit('saveStatus', true)
        }
      };
      next();
    },
    computeFileHash: async function (file) {
      const buffer = await file.arrayBuffer();
      const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    },
    createChunks: function (file) {
      const size = this.chunkSize;
      const chunks = [];
      let start = 0;
      let index = 0;
      while (start < file.size) {
        const end = Math.min(start + size, file.size);
        chunks.push({ index, blob: file.slice(start, end) });
        start = end;
        index++;
      }
      return chunks;
    },
    saveChunkProgress(hash, idx) {
      const key = 'audio_chunk_' + hash;
      const raw = localStorage.getItem(key);
      const set = raw ? JSON.parse(raw) : [];
      if (!set.includes(idx)) set.push(idx);
      localStorage.setItem(key, JSON.stringify(set));
    },
    loadChunkProgress(hash) {
      const key = 'audio_chunk_' + hash;
      const raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : [];
    },
    clearChunkProgress(hash) {
      const key = 'audio_chunk_' + hash;
      localStorage.removeItem(key);
    },
    uploadChunkOnce: async function (task, chunk) {
      const fd = new FormData();
      fd.append('file', chunk.blob);
      fd.append('fileName', task.name);
      fd.append('fileHash', task.hash);
      fd.append('chunkIndex', chunk.index);
      fd.append('totalChunks', task.totalChunks);
      fd.append('tag', this.batchUploadTag);
      const res = await this.$request.post('/audio/uploadChunk', fd, { timeout: 120000 });
      if (res && res.status === 200) return true;
      return false;
    },
    uploadChunkWithRetry: async function (task, chunk) {
      for (let attempt = 0; attempt < this.retryLimit; attempt++) {
        try {
          const ok = await this.uploadChunkOnce(task, chunk);
          if (ok) return true;
        } catch (e) {}
        await new Promise(r => setTimeout(r, 1000 * Math.pow(2, attempt)));
      }
      return false;
    },
    finalizeMerge: async function (task) {
      const fd = new FormData();
      fd.append('fileHash', task.hash);
      fd.append('fileName', task.name);
      fd.append('name', task.name.replace(/\.[^/.]+$/, ''));
      fd.append('tag', this.batchUploadTag);
      fd.append('moreTag', '');
      fd.append('heat', 4000);
      fd.append('supportClone', 1);
      fd.append('pid', '');
      fd.append('isLock', 0);
      fd.append('hotness', 0);
      fd.append('cloneHeat', 0);
      fd.append('cloneHotness', 0);
      const res = await this.$request.post('/audio/mergeChunks', fd, { timeout: 120000 });
      if (res && res.status === 200) return true;
      return false;
    },
    singleUploadFallback: async function (task) {
      const fd = new FormData();
      fd.append('file', task.file);
      fd.append('name', task.name.replace(/\.[^/.]+$/, ''));
      fd.append('tag', this.batchUploadTag);
      fd.append('moreTag', '');
      fd.append('heat', 4000);
      fd.append('supportClone', 1);
      fd.append('pid', '');
      fd.append('isLock', 0);
      fd.append('hotness', 0);
      fd.append('cloneHeat', 0);
      fd.append('cloneHotness', 0);
      const res = await this.$request.post('/audio/addAudioPack', fd, { timeout: 180000 });
      return res && res.status === 200;
    },
    uploadSingleTask: async function (task) {
      task.status = 'uploading';
      try {
        task.hash = await this.computeFileHash(task.file);
        const doneSet = this.loadChunkProgress(task.hash);
        const chunks = this.createChunks(task.file);
        task.totalChunks = chunks.length;
        for (let i = 0; i < chunks.length; i++) {
          const c = chunks[i];
          if (doneSet.includes(c.index)) {
            task.uploadedChunks++;
            task.progress = Math.floor(task.uploadedChunks / task.totalChunks * 100);
            continue;
          }
          const ok = await this.uploadChunkWithRetry(task, c);
          if (!ok) throw new Error('chunk_fail');
          this.saveChunkProgress(task.hash, c.index);
          task.uploadedChunks++;
          task.progress = Math.floor(task.uploadedChunks / task.totalChunks * 100);
        }
        const merged = await this.finalizeMerge(task);
        if (!merged) {
          const fallback = await this.singleUploadFallback(task);
          if (!fallback) throw new Error('finalize_fail');
        }
        this.clearChunkProgress(task.hash);
        task.progress = 100;
        task.progressStatus = 'success';
        task.status = 'completed';
      } catch (e) {
        const ok = await this.singleUploadFallback(task);
        if (ok) {
          task.progress = 100;
          task.progressStatus = 'success';
          task.status = 'completed';
          return;
        }
        task.progressStatus = 'exception';
        task.status = 'failed';
      }
    },
    addAudioPack: function () {
      if (this.audioPack.name === undefined || this.audioPack.name === "") {
        this.showErrorMessage("请输入语音名称")
        return
      }
      if (this.audioPack.tag === undefined || this.audioPack.tag === "") {
        this.showErrorMessage("请输入语音所属于的标签")
        return
      }
      if (this.audioPack.heat === undefined || this.audioPack.heat === "") {
        this.showErrorMessage("请输入语音热度")
        return
      }
      if (this.audioPack.file === undefined || this.audioPack.file == null) {
        this.showErrorMessage("请选择一个语音文件")
        return
      }
      this.showLoading = true;
      const that = this;
      const params = new FormData()
      params.append("file", this.audioPack.file)
      params.append("name", this.audioPack.name)
      params.append("tag", this.audioPack.tag)
      params.append("moreTag", this.audioPack.moreTag)
      params.append("heat", this.audioPack.heat)
      params.append("supportClone", this.audioPack.supportClone != null ? this.audioPack.supportClone : 1)
      params.append("pid", this.audioPack.pid || 0)
      params.append("isLock", this.audioPack.isLock || 0)
      params.append("hotness", this.audioPack.hotness || 0)
      params.append("cloneHeat", this.audioPack.cloneHeat || 0)
      params.append("cloneHotness", this.audioPack.cloneHotness || 0)

      this.$request.post("/audio/addAudioPack", params)
          .then(function (data) {
            that.showLoading = false
            if (data.status === 200) {
              that.$message.success('添加成功')
              that.$emit('saveStatus', true)
            } else {
              that.showErrorMessage(data.message)
            }
          }).catch(function (err) {
        that.showLoading = false
        that.showErrorMessage("网络错误")
      })
    },
    updateAudioPack: function () {
      if (this.audioPack.name === undefined || this.audioPack.name === "") {
        this.showErrorMessage("请输入字体名称")
        return
      }
      if (this.audioPack.tag === undefined || this.audioPack.tag === "") {
        this.showErrorMessage("请输入语音所属于的标签")
        return
      }
      this.showLoading = true;
      const that = this;
      const params = new FormData()
      if (this.audioPack.file !== undefined && null !== this.audioPack.file) {
        params.append("file", this.audioPack.file)
      }
      params.append("id", this.audioPack.id)
      params.append("name", this.audioPack.name)
      params.append("tag", this.audioPack.tag)
      params.append("moreTag", this.audioPack.moreTag)
      params.append("originUrl", this.audioPack.url)
      params.append("heat", this.audioPack.heat)
      params.append("supportClone", this.audioPack.supportClone || 0)
      params.append("pid", this.audioPack.pid || 0)
      params.append("isLock", this.audioPack.isLock || 0)
      params.append("hotness", this.audioPack.hotness || 0)
      params.append("cloneHeat", this.audioPack.cloneHeat || 0)
      params.append("cloneHotness", this.audioPack.cloneHotness || 0)
      this.$request.post("/audio/updateAudioPack", params)
          .then(function (data) {
            that.showLoading = false
            if (data.status === 200) {
              that.$confirm("修改成功", "提示", {
                confirmButtonText: '确定',
                showClose: false,
                showCancelButton: false,
                center: true,
                type: 'success'
              }).then(function () {
                that.$emit('saveStatus', true)
              })
            } else {
              that.showErrorMessage(data.data)
            }
          }).catch(function (err) {
        that.showLoading = false
        that.showErrorMessage("网络错误," + err)
      })
    },
  },
}
</script>

<style scoped>
.imageBox {
  width: 100%;
  min-height: 300px;
}

.btn /deep/ .el-form-item__content {
  margin-left: 0 !important;
  text-align: center;
}

.upload-item /deep/ .el-form-item__content {
  line-height: normal;
}

.upload-large /deep/ .el-upload {
  width: 100%;
}

.upload-large /deep/ .el-upload-dragger {
  width: 100%;
  height: 180px;
}

.upload-large /deep/ .el-icon-upload {
  font-size: 67px;
  margin: 20px 0 16px;
}

.input {
  width: 300px;
}

.font_preview {
  width: 200px;
  height: 40px;
  font-family: fontPreview;
}

.font_preview canvas, .font_preview img {
  width: 100px;
  height: 40px;
}
</style>
